import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { MdOutlineResetTv } from 'react-icons/md';

const GlobalProductListFilterDrawer = ({
	filterDrawerVisible,
	setFilterDrawerVisible,
	categoryNameSearch,
	setCategoryNameSearch,
	searchText,
	setSearchText,
	selectedParentCategory,
	setSelectedParentCategory,
	loadOptions,
	loading,
	handleResetFilter,
	handleSearch,
}) => {
	return (
		<Sidebar
			visible={filterDrawerVisible}
			position="right"
			onHide={() => setFilterDrawerVisible(false)}
			style={{ width: '28rem', maxWidth: '90vw' }}
			header="Filters"
		>
			<div className="d-flex flex-column justify-content-between h-100 gap-1">
				<div>
					<div className="field">
						<label htmlFor="categoryNameSearch">Category Name</label>
						<span className="p-input-icon-left w-100">
							<i className="pi pi-search" />
							<InputText
								id="categoryNameSearch"
								type="search"
								value={categoryNameSearch}
								onInput={(e) => setCategoryNameSearch(e.target.value)}
								placeholder="Category Name Search"
								className="md:h-3rem w-100 p-inputtext-sm"
								onKeyPress={(e) => {
									if (e.key === 'Enter') handleSearch();
								}}
							/>
						</span>
					</div>

					<div className="field">
						<label htmlFor="productSearch">Search Product</label>
						<span className="p-input-icon-left w-100">
							<i className="pi pi-search" />
							<InputText
								id="productSearch"
								type="search"
								value={searchText}
								onInput={(e) => setSearchText(e.target.value)}
								placeholder="Search..."
								className="md:h-3rem w-100 p-inputtext-sm"
								onKeyPress={(e) => {
									if (e.key === 'Enter') handleSearch();
								}}
							/>
						</span>
					</div>

					<div className="field">
						<label htmlFor="parentCategory">Parent Category</label>
						<AsyncSelect
							inputId="parentCategory"
							cacheOptions
							loadOptions={loadOptions}
							defaultOptions
							onChange={setSelectedParentCategory}
							value={selectedParentCategory}
							styles={{
								control: (base) => ({
									...base,
									padding: '5px',
									width: '100%',
								}),
							}}
						/>
					</div>
				</div>

				<div className="d-flex gap-2 justify-content-between mt-2 pt-3 border-top prime-react-btn">
					<Button
						variant="outline-secondary"
						disabled={loading}
						onClick={handleResetFilter}
						className="w-100"
					>
						Reset
					</Button>
					<button
						disabled={loading}
						onClick={handleSearch}
						className="w-100 btn submit-btn text-white"
					>
						Search
					</button>
				</div>
			</div>
		</Sidebar>
	);
};

export default GlobalProductListFilterDrawer;

